import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import moment from "moment";
import "@/assets/css/reset.css";
import "@/assets/css/color.css";
import Vant from "vant";
import "vant/lib/index.css";
import { DatetimePicker, Calendar, Notify } from "vant";
// 懒加载
import { Lazyload } from "vant";
import vueEsign from "vue-esign";
const app = createApp(App);

app.config.globalProperties.$moment = moment;
app.use(Lazyload, {
  lazyComponent: true,
});

app.use(moment);
app.use(vueEsign);
app.use(Vant);
app.use(DatetimePicker);
app.use(Calendar);
app.use(Notify);
app.use(store).use(router).mount("#app");
